import api from '@http/api';

interface IResponsePessoaTriagem {
  error: boolean;
  response?: IPessoaTriagem;
}

export interface IPessoaTriagem {
  id_pessoa: number;
  nome_pessoa: string;
  nome_fantasia: string;
  documento: string;
  data_cadastro: string;
  cadastrado_por: string;
  sexo: string;
  data_nascimento: string;
  documento_indicador: string;
  pessoa_responsavel: string;
  pessoa_indicador: string;
  id_usuario_alteracao: string;
  data_alteracao: string;

}

export interface IPessoa {
  id: number;
  nome: string;
  nome_fantasia: string;
  data_nascimento: any;
  documento: string;
  sexo: number;
  id_pessoa_responsavel: number;
  id_pessoa_indicador: number;
}

export interface IRequestUpdatePessoaPerfil {
  pessoa: IPessoa;
}



export interface IDesativacaoDebitoAutomaticoMotivos {
  id: number;
  descricao: string;
}

class ComponentPerfilServices {
    public async GetPegaInformacoesFixasCadastro(id_perfil: any): Promise<IResponsePessoaTriagem> {
    return await api
      .get<IPessoaTriagem>(`api/Triagem/PegaInformacoesFixasCadastro?id_perfil=${id_perfil}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };

      })
      .catch(error => {
        return {
          error: true,
        };
      });

  }

  public async UpdatePessoaPerfilByPessoaId(
    pessoa: IRequestUpdatePessoaPerfil,
  ) {
    console.log(pessoa);
    return await api
      .put('/api/Pessoa/UpdatePessoaByPessoaId', pessoa)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }
}






export default ComponentPerfilServices;
